import { render } from "./recentGlitzs.vue?vue&type=template&id=70b4e5fd&scoped=true"
import script from "./recentGlitzs.vue?vue&type=script&lang=js"
export * from "./recentGlitzs.vue?vue&type=script&lang=js"

import "./recentGlitzs.vue?vue&type=style&index=0&id=70b4e5fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b4e5fd"]])

export default __exports__